import { CHART_COLORS } from '@/constants/chartColors'
import { useTranslation } from 'react-i18next'

interface CustomLegendProps {
    hasComparison: boolean
    currentPeriodLabel: string
    comparePeriodLabel: string
}

const CustomLegend = ({
    hasComparison,
    currentPeriodLabel,
    comparePeriodLabel,
}: CustomLegendProps) => {
    const { t } = useTranslation()

    const legendItems = [
        {
            key: 'total_revenue',
            label: t('employees.performance.total_revenue'),
            color: CHART_COLORS.PRIMARY_BLUE,
        },
        {
            key: 'renewal',
            label: t('employees.performance.renewal'),
            color: CHART_COLORS.EMERALD_GREEN,
        },
        {
            key: 'new_sale',
            label: t('employees.performance.new_sale'),
            color: CHART_COLORS.INDIGO_PURPLE,
        },
        {
            key: 'upsell',
            label: t('employees.performance.upsell'),
            color: CHART_COLORS.AMBER_ORANGE,
        },
    ]

    return (
        <div className="grid xs:grid-cols-1 md:grid-cols-4 gap-2">
            {legendItems.map((item) => (
                <div key={item.key} className="flex items-center gap-1.5">
                    {/* Solid line for current period */}
                    <div
                        className="w-6 h-0.5"
                        style={{ backgroundColor: item.color }}
                    />
                    <span className="text-xs text-gray-700">
                        {hasComparison
                            ? `${item.label} (${currentPeriodLabel})`
                            : item.label}
                    </span>
                </div>
            ))}
            {hasComparison &&
                legendItems.map((item) => (
                    <div
                        key={`${item.key}-compare`}
                        className="flex items-center gap-1.5"
                    >
                        {/* Dashed line for comparison period */}
                        <div
                            className="w-6 h-0.5"
                            style={{
                                backgroundImage: `linear-gradient(to right, ${item.color} 50%, transparent 50%)`,
                                backgroundSize: '6px 2px',
                            }}
                        />
                        <span className="text-xs text-gray-500">
                            {`${item.label} (${comparePeriodLabel})`}
                        </span>
                    </div>
                ))}
        </div>
    )
}

export default CustomLegend
